import { createBrowserHistory } from "history"
import { createHashHistory } from "history"
export const hashHistory = createHashHistory();
export const browserHistory = createBrowserHistory();